/*
  IW Nuevo: collection header behavior (phase 2.3, T19). Loaded with defer by sections/main-collection-banner.liquid.

  <iw-read-more>: CSS (assets/iw-collection.css) clamps the description while the element has no [open]. The
  "Leer más" button starts hidden and shows only when the clamp actually hides text; a ResizeObserver and the font
  load re-check it. The button toggles [open], aria-expanded and its label ("Leer más" / "Leer menos").

  Chip row (snippets/iw-collection-subnav.liquid): below 990px it scrolls sideways, so the current chip is brought into
  view once on load. Only the row's own scrollLeft changes; the page never moves.
*/
class IwReadMore extends HTMLElement {
  connectedCallback() {
    this.text = this.querySelector('.iw-coll__desc');
    this.button = this.querySelector('.iw-coll__more');
    if (!this.text || !this.button) return;

    // Bind once: a detached and re-attached element runs connectedCallback again.
    if (!this.bound) {
      this.button.addEventListener('click', () => this.toggle());
      this.bound = true;
    }

    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.text);
    }
    if (document.fonts) document.fonts.ready.then(() => this.measure());
    this.measure();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  // Closed: the button shows only when the clamped box hides part of the text. Open: it stays, to close again.
  measure() {
    if (this.hasAttribute('open')) return;
    this.button.hidden = this.text.scrollHeight <= this.text.clientHeight + 1;
  }

  toggle() {
    const open = !this.hasAttribute('open');
    this.toggleAttribute('open', open);
    this.button.setAttribute('aria-expanded', String(open));
    this.button.textContent = open ? 'Leer menos' : 'Leer más';
  }
}

if (!customElements.get('iw-read-more')) customElements.define('iw-read-more', IwReadMore);

document.querySelectorAll('.iw-subnav__list').forEach((list) => {
  const current = list.querySelector('[aria-current="page"]');
  if (!current || list.scrollWidth <= list.clientWidth) return;

  const listBox = list.getBoundingClientRect();
  const chipBox = current.getBoundingClientRect();
  if (chipBox.left >= listBox.left && chipBox.right <= listBox.right) return;

  // Center the chip in the row.
  list.scrollLeft += chipBox.left - listBox.left - (listBox.width - chipBox.width) / 2;
});
